<template>
  <div>
    <vs-card>
      <ag-grid-vue
        style="width: 100%; height: 400px; margin-top: 25px"
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefs"
        :rowData="toplamaList"
        :localeText="localeText"
        @grid-ready="onGridReady"
        @first-data-rendered="onFirstDataRendered"
      >
      </ag-grid-vue>
    </vs-card>
  </div>
</template>
<script>
import state from "../../store/state";
import Store from "../../store/store";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import TextGorunumCellRenderer from "./CellRenderers/TextGorunumCellRenderer.vue";
export default {
  data() {
    return {
      toplamaList: [],
      localeText: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      columnDefs: null,
    };
  },
  components: {
    TextGorunumCellRenderer,
    AgGridVue,
  },
  created() {
    this.secilenPartiUrunleri();
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;
  },
  methods: {
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    secilenPartiUrunleri() {
      const vs = this.$vs;
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        pazaryeri: "Toptan",
        partiNo: "Toptan",
        token: Store.state.tokenId,
      };
      soap.createClient(url, function (err, client) {
        client.partiUrunleri(args, function (err, result) {
          if (result.partiUrunleriResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          } else {
            try {
              vm.veriler = JSON.parse(result.partiUrunleriResult);
              console.log(vm.veriler);
              vm.toplamaList = vm.veriler;
            } catch (error) {
              console.log(error);
            }
          }
        });
      });
    },
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "Pazaryeri",
        field: "pazaryeri",
        sortable: true,
        filter: "agSetColumnFilter",
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Sipariş Numarası",
        field: "orderNumber",
        sortable: true,
        filter: "agSetColumnFilter",
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Raf Numarası",
        field: "rafNo",
        sortable: true,
        filter: "agSetColumnFilter",
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Barkod",
        field: "barkod",
        sortable: true,
        filter: "agSetColumnFilter",
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Ürün Kodu",
        field: "urunKodu",
        sortable: true,
        filter: "agSetColumnFilter",
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Ürün Muhasebe Kodu",
        field: "urunMuhKodu",
        sortable: true,
        filter: "agSetColumnFilter",
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Stok Adı",
        field: "stokAdi",
        sortable: true,
        filter: "agSetColumnFilter",
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Siparis Adet",
        field: "siparisAdet",
        sortable: true,
        filter: "agTextColumnFilter",
        cellRenderer: "TextGorunumCellRenderer",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
    ];
  },
};
</script>
